{
  "cta": {
    "create-a-chart": "Crea una tabella"
  },
  "breadcrumb": {
    "dashboard": "Dashboard",
    "products": "Prodotti",
    "charts": "Tabelle",
    "restock-alerts": "Avvisi di rifornimento",
    "settings": "Impostazioni",
    "setting": "Impostazioni",
    "account": "Account",
    "personal": "Personale",
    "organization": "Organizzazione",
    "appearance": "Aspetto",
    "themes": "Temi",
    "button": "Pulsante",
    "font-family": "Famiglia di caratteri",
    "uploads": "File caricati",
    "dimensions": "Dimensioni",
    "notifications": "Notifiche",
    "analytic": "Analisi",
    "analytics": "Analisi",
    "restock-settings": "Impostazioni di rifornimento",
    "inventory": "Avvisi di rifornimento",
    "plans": "Piani",
    "billing": "Fatturazione",
    "overview": "Panoramica",
    "plan-and-usage": "Piano e utilizzo",
    "chart-views": "Visualizzazioni tabella",
    "add-to-cart": "Aggiungi al carrello",
    "buy-now": "Acquista ora",
    "size-recommendations": "Consigli sulle taglie",
    "stock-notifications": "Notifiche di magazzino",
    "reports": "Report",
    "comparison": "Confronto",
    "images": "File caricati",
    "sidekick": "Sidekick",
    "import": "Importazione",
    "contact": "Contatti",
    "help-articles": "Articoli di aiuto",
    "new": "Nuovo"
  },
  "page": {
    "dashboard": {
      "table-style-chart": "Tabella in stile griglia",
      "build-a-fully-custom-grid-with-complete-control-over-every-row-column-and-measurement-unit-best-for-complex-sizing-across-multiple-regions": "Crea una griglia completamente personalizzata con il pieno controllo su ogni riga, colonna e unità di misura. Ideale per taglie complesse in più regioni.",
      "create-table-chart": "Crea tabella a griglia",
      "create-from-product": "Crea dal prodotto",
      "start-from-template": "Inizia da un modello",
      "browse-templates": "Sfoglia i modelli",
      "create-with-drag-drop": "Crea con trascina e rilascia",
      "creating": "Creazione in corso",
      "how-would-you-like-to-build-your-chart": "Come vorresti<br /><span class=\"text-primary\">creare la tua tabella taglie?</span>",
      "choose-a-method-below-or-tell-us-what-you-sell-and-we-ll-highlight-the-best-fit": "Scegli un metodo qui sotto, oppure dicci cosa vendi e ti indicheremo l'opzione migliore.",
      "fastest-setup-2-min": "Configurazione più veloce · ~2 min",
      "used-by-1000-merchants": "Utilizzato da oltre 1000 negozianti",
      "auto-generate-a-matching-size-chart-directly-from-your-existing-shopify-variant-data-no-manual-entry-it-reads-your-product-and-fills-the-table-for-you": "Genera automaticamente una tabella taglie corrispondente direttamente dai dati delle varianti Shopify esistenti. Nessun inserimento manuale: legge il tuo prodotto e compila la tabella per te",
      "garment-templates-ready-to-use": "Modelli di capi pronti all'uso",
      "pick-from-ready-made-templates-for-tops-bottoms-shoes-belts-bags-and-more-customise-any-field-after-great-for-getting-started-in-under-a-minute": "Scegli tra modelli già pronti per capi superiori, inferiori, scarpe, cinture, borse e altro ancora. Personalizza qualsiasi campo in seguito, ideale per iniziare in meno di un minuto.",
      "drag-drop-no-data-needed-upfront": "Trascina e rilascia · nessun dato necessario in anticipo",
      "upload-any-product-image-and-annotate-measurements-directly-on-it-with-drag-drop-pins-ideal-for-shoes-bags-accessories-and-equipment": "Carica un'immagine qualsiasi del prodotto e annota le misure direttamente su di essa con punti da trascinare e rilasciare. Ideale per scarpe, borse, accessori e attrezzatura.",
      "excel-like": "Simile a Excel",
      "auto-generated": "Generato automaticamente",
      "annotate-on-image": "Annota sull'immagine",
      "what-are-you-selling": "Cosa vendi?",
      "category-clothing-apparel": "Abbigliamento e capi",
      "category-shoes": "Scarpe",
      "category-accessories": "Accessori",
      "category-other": "Qualcos'altro",
      "start-date": "Data di inizio",
      "end-date": "Data di fine"
    },
    "products": {
      "select-a-product-to-create-or-link-a-size-chart-for-that-product": "Seleziona un prodotto per creare o collegare una tabella taglie per quel prodotto.",
      "product-name": "Nome del prodotto",
      "best-selling": "Più venduti",
      "most-selling": "Più venduti prima",
      "least-selling": "Meno venduti",
      "best-selling-unavailable": "I dati di vendita non sono ancora disponibili, quindi i prodotti sono mostrati in base all'ultimo aggiornamento.",
      "chart-attached": "Tabella allegata",
      "shopify-status": "Stato Shopify",
      "search-placeholder": "Cerca tra tutti i prodotti...",
      "vendors": "Fornitori",
      "tags": "Tag",
      "statuses": "Stati",
      "collections": "Collezioni",
      "types": "Tipi",
      "add-filter": "Aggiungi filtro",
      "categories": "Categorie",
      "search-and-filter-tooltip": "Cerca e filtra (F)",
      "import-selection": "Importa selezione",
      "failed-import-measurements": "Impossibile importare le misure",
      "product-updated": "Prodotto aggiornato con successo"
    },
    "charts": {
      "create-edit-duplicate-or-link-a-chart-to-a-product-from-here": "Crea, modifica, duplica o collega una tabella a un prodotto da qui.",
      "chart-name": "Nome della tabella",
      "chart-type": "Tipo di tabella",
      "linked-to": "Collegato a",
      "last-updated": "Ultimo aggiornamento",
      "delete-x-charts": "Elimina {{ x }} tabelle",
      "assigned-products": "Prodotti assegnati",
      "failed-to-fetch-products-data": "Impossibile recuperare i dati dei prodotti",
      "delete-chart": "Elimina tabella",
      "are-you-sure-you-want-to-delete-selected-chart-s-all-products-using-chart-s-will-be-unassigned": "Sei sicuro di voler eliminare la/le tabella/e selezionata/e? Tutti i prodotti che utilizzano la/le tabella/e non saranno più assegnati.",
      "successfully-deleted-chart-s": "Tabella/e eliminata/e con successo!",
      "successfully-duplicated-chart": "Tabella duplicata con successo!",
      "turn-this-into-a-conversion-chart": "Trasforma questa in una tabella di conversione",
      "upgradable-tooltip": "Questa tabella a griglia sembra una tabella taglie strutturata e può essere convertita.",
      "convert-to-size-chart": "Converti in tabella taglie",
      "convertibility-failed": "Non siamo riusciti a verificare quali tabelle a griglia possono essere convertite.",
      "convert": {
        "table-chart-info-callout": "Questa tabella a griglia può essere aggiornata a una tabella taglie intelligente",
        "table-chart-info-callout-message": "La conversione mappa la tua griglia alle dimensioni della tua libreria, sbloccando una guida visiva alle misure e informazioni sul modello che una tabella semplice non può mostrare.",
        "successfully-converted": "Convertita con successo in una tabella taglie!",
        "detected-sizes": "Taglie rilevate",
        "at-least-two-sizes-are-needed": "Sono necessarie almeno due taglie per convertire questa tabella.",
        "unnamed-row": "Riga senza nome",
        "ignore-this-row": "Ignora questa riga",
        "this-dimension-is-already-mapped": "Questa dimensione è già mappata a un'altra riga.",
        "map-at-least-one-row": "Mappa almeno una riga a una dimensione.",
        "finish-your-measurement-guide": "Completa la tua guida alle misure",
        "measurement-points-without-values": "Punti di misurazione senza valori ({{ x }})",
        "fill-them-in-after-converting": "La tua immagine selezionata li mostra, ma la tua tabella non aveva tali righe. Compila i loro valori dopo la conversione.",
        "measurements-without-points": "Misure senza un punto sulla tua immagine ({{ x }})",
        "no-image-selected-yet": "Nessuna immagine ancora selezionata",
        "upload-an-image-then-drag-points": "Carica un'immagine, poi trascina i punti di misurazione su di essa.",
        "your-image-has-no-measurement-points": "La tua immagine selezionata non ha ancora punti di misurazione",
        "drag-measurement-points-onto-the-image": "Trascina i punti di misurazione sull'immagine in modo che gli acquirenti possano vedere dove misurare.",
        "plus-x-more": "+{{ x }} altri",
        "satisfied-button": "Sembra buono — rendi questa la mia tabella attiva",
        "satisfied-explanation": "La tua tabella a griglia verrà annullata dalla pubblicazione, questa tabella verrà pubblicata e i suoi prodotti assegnati verranno trasferiti.",
        "satisfied-success": "Questa tabella è ora attiva!",
        "step-x-of-y": "Passaggio {{ x }} di {{ y }}",
        "choose-product-type": "Scegli il tipo di prodotto",
        "well-match-your-table-to-a-visual": "Abbineremo la tua tabella al prodotto visivo giusto.",
        "save-settings": "Salva impostazioni",
        "review-table-mapping": "Rivedi la mappatura della tabella",
        "confirm-the-rows-to-convert": "Conferma le righe che dovremmo convertire.",
        "existing-table": "Tabella esistente",
        "sizes": "Taglie",
        "row": "Riga",
        "column": "Colonna",
        "x-rows-need-review": "{{ x }} righe necessitano di revisione",
        "couldnt-match-this-row": "Non siamo riusciti ad abbinare automaticamente questa misura",
        "change-match": "Cambia abbinamento",
        "view-values": "Visualizza valori",
        "hide-values": "Nascondi valori",
        "matched-automatically": "Abbinato automaticamente",
        "edit-matches": "Modifica abbinamenti",
        "create-preview": "Crea anteprima",
        "preview-ready": "Anteprima pronta",
        "open-it-to-finish-the-missing-values": "Aprila per completare i valori mancanti.",
        "converted": "Convertita",
        "open-preview": "Apri anteprima",
        "you-can-add-them-in-the-preview": "Puoi aggiungerli nell'anteprima."
      }
    },
    "inventory": {
      "collect-emails-and-send-automatic-back-in-stock-notifications-setup-notification": "Raccogli le email e invia notifiche automatiche di rifornimento. Configura notifica",
      "here": "qui",
      "successfully-export-inventory-data": "Dati di magazzino esportati con successo",
      "active-your-store-inventory-notification-feature": "Attiva la funzione di notifica di magazzino del tuo negozio",
      "in-order-to-receive-users-subscribed-for-your-products": "per ricevere gli utenti iscritti ai tuoi prodotti.",
      "your-subscribers-have-been-delegeted-to-your": "I tuoi iscritti sono stati trasferiti al tuo"
    },
    "setting": {
      "storefront-popup-preview": "Anteprima popup del negozio",
      "add-to-cart": "Aggiungi al carrello",
      "buy-now": "Acquista ora",
      "sans-serif": "Sans serif",
      "serif": "Serif",
      "email-body-is-required": "Il corpo dell'email è obbligatorio",
      "list": "Elenco",
      "category-image": "Immagine categoria",
      "pay-over-usage-cost": "Paga il costo di sovrautilizzo",
      "over-usage-count": "Conteggio sovrautilizzo",
      "over-usage-cost": "Costo di sovrautilizzo",
      "x-usages": "{{ x }} utilizzi",
      "failed-to-pay-over-usage-cost": "Impossibile pagare il costo di sovrautilizzo",
      "manage-your-personal-information-and-account-perferences": "Gestisci le tue informazioni personali e le preferenze dell'account.",
      "manage-your-organization-contact-information-and-address": "Gestisci le informazioni di contatto e l'indirizzo della tua organizzazione.",
      "manage-your-billing-overview": "Rivedi i dettagli di fatturazione, il piano e le informazioni di pagamento.",
      "manage-your-plan-and-usage": "Visualizza il tuo piano attuale e i limiti di utilizzo.",
      "manage-your-measurement-dimensions": "Gestisci le dimensioni di misura utilizzate nelle tue tabelle taglie.",
      "dimension-translations": "Traduzioni per il negozio",
      "dimension-translations-description": "Inserisci l'etichetta che gli acquirenti dovrebbero vedere per ogni lingua del negozio supportata. Lascia vuoto per utilizzare il nome predefinito.",
      "default-dimension-name": "Nome dimensione predefinito",
      "dimension-name-description": "Utilizzato in tutta la dashboard e come opzione di riserva del negozio quando non è fornita alcuna traduzione.",
      "storefront-label": "Etichetta del negozio",
      "naming": "Denominazione",
      "affecting-data": "Dati interessati",
      "first-name-is-required": "Il nome è obbligatorio",
      "last-name-is-required": "Il cognome è obbligatorio",
      "subscribed-for-our-latest-news-exclusive-offers-and-exciting-updates": "Iscritto per ricevere le nostre ultime notizie, offerte esclusive e aggiornamenti interessanti.",
      "contact-information": "Informazioni di contatto",
      "contact-name": "Nome del contatto",
      "contact-name-is-required": "Il nome del contatto è obbligatorio!",
      "contact-email": "Email di contatto",
      "contact-email-is-required": "L'email di contatto è obbligatoria!",
      "contact-email-is-invalid": "L'email di contatto non è valida!",
      "company-organization-name": "Nome dell'azienda/organizzazione",
      "company-organization-name-is-required": "Il nome dell'azienda/organizzazione è obbligatorio",
      "street-address": "Indirizzo",
      "street-address-is-required": "L'indirizzo è obbligatorio!",
      "street-address-2": "Indirizzo 2",
      "city": "Città",
      "city-is-required": "La città è obbligatoria!",
      "state-province-region": "Stato/Provincia/Regione",
      "state-province-region-is-required": "Stato/Provincia/Regione è obbligatorio!",
      "country": "Paese",
      "country-is-required": "Il paese è obbligatorio!",
      "postal-zip-code": "Codice postale",
      "postal-zip-code-is-required": "Il codice postale è obbligatorio!",
      "themes": "Temi",
      "customise-your-app-look-choose-a-colour-that-best-represents-your-brand": "Personalizza l'aspetto della tua app! Scegli un colore che rappresenti al meglio il tuo brand",
      "sunset-ember": "Braci al tramonto",
      "classic-noir": "Nero classico",
      "system-background-colour": "Colore di sfondo del sistema",
      "customise-your-button": "Personalizza il tuo pulsante",
      "customise-your-button-text-colour-and-style-to-match-your-brand": "Personalizza testo, colore e stile del pulsante per adattarli al tuo brand.",
      "what-should-the-button-say": "Cosa dovrebbe dire il pulsante?",
      "label-button-is-required": "L'etichetta del pulsante è obbligatoria!",
      "text-colour": "Colore del testo",
      "text-colour-is-required": "Il colore del testo è obbligatorio!",
      "please-input-valid-hex-color-code": "Inserisci un codice colore esadecimale valido",
      "background-color": "Colore di sfondo",
      "background-colour-is-required": "Il colore di sfondo è obbligatorio!",
      "font-size-in-px": "Dimensione del carattere in px",
      "font-size-in-px-is-required": "La dimensione del carattere in px è obbligatoria!",
      "border-radius": "Raggio del bordo",
      "border-radius-is-required": "Il raggio del bordo è obbligatorio!",
      "successfully-updated-button-style": "Stile del pulsante aggiornato con successo",
      "font-family": "Famiglia di caratteri",
      "customise-your-font": "Personalizza il tuo carattere",
      "match-your-store-look-and-feel-by-updating-the-font-across-your-size-charts": "Abbina l'aspetto del tuo negozio aggiornando il carattere in tutte le tue tabelle taglie.",
      "select-a-font-from-the-list-bellow": "Seleziona un carattere dall'elenco qui sotto.",
      "search-font": "Cerca carattere...",
      "fetching-fonts": "Recupero dei caratteri in corso...",
      "showing-x-fonts": "Visualizzazione di {{ x }} caratteri",
      "sort-by-x": "Ordina per {{ x }}",
      "most-popular": "Più popolari",
      "here-how-it-will-look-on-your-shop": "Ecco come apparirà nel tuo negozio",
      "it-ll-updated-across-all-your-chart-displays": "Verrà aggiornato in tutte le visualizzazioni delle tue tabelle.",
      "update-font-across-all-size-charts": "Aggiorna il carattere in tutte le tabelle taglie",
      "choose-a-font-to-match-your-store-style": "Scegli un carattere che si adatti allo stile del tuo negozio",
      "apply-font": "Applica carattere",
      "font-applied-successfully": "Carattere applicato con successo!",
      "manage-and-delete-your-uploaded-images-removing-a-file-is-permanent-and-cannot-be-undone": "Gestisci ed elimina le immagini caricate. La rimozione di un file è permanente e non può essere annullata.",
      "do-you-want-to-delete-image": "Vuoi eliminare l'immagine?",
      "image-deleted-successfully": "Immagine eliminata con successo",
      "chart-list": "Elenco tabelle",
      "delete-x-dimensions": "Elimina {{ x }} dimensioni",
      "view-affecting-data": "Visualizza dati interessati",
      "no-data-will-be-affected": "Nessun dato sarà interessato.",
      "do-you-want-to-delete-selected-dimensions": "Vuoi eliminare le dimensioni selezionate?",
      "any-annotation-sets-and-charts-currently-using-these-dimensions-will-have-its-annotation-and-data-removed": "Tutti i set di annotazioni e le tabelle che attualmente utilizzano queste dimensioni avranno le loro annotazioni e i loro dati rimossi",
      "any-annotation-sets-and-charts-currently-using-these-dimensions-will-have-its-name-changed": "Tutti i set di annotazioni e le tabelle che attualmente utilizzano queste dimensioni avranno il loro nome modificato",
      "delete-dimension": "Elimina dimensione",
      "successfully-deleted-dimension": "Dimensione/i eliminata/e con successo!",
      "successfully-update-dimension": "Dimensione aggiornata con successo!",
      "configure-how-back-in-stock-notifications-work-for-your-customers": "Configura come funzionano le notifiche di rifornimento per i tuoi clienti",
      "activate-back-in-stock-notifications": "Attiva le notifiche di rifornimento",
      "allow-shoppers-to-subscribe-for-alerts-when-a-size-or-product-is-sold-out-notifications-will-be-sent-automatically-once-stock-is-available": "Consenti agli acquirenti di iscriversi agli avvisi quando una taglia o un prodotto è esaurito. Le notifiche verranno inviate automaticamente non appena il prodotto sarà nuovamente disponibile.",
      "notification-channels": "Canali di notifica",
      "third-party-service": "Servizio di terze parti",
      "sms": "SMS",
      "coming-soon": "Prossimamente",
      "signup-experience-design": "Design dell'esperienza di iscrizione",
      "form-display": "Visualizzazione del modulo",
      "modal-popup": "Popup modale",
      "email-template-customisation": "Personalizzazione del modello email",
      "subject-line": "Oggetto",
      "subject-line-is-required": "L'oggetto è obbligatorio",
      "your-size-is-back-in-stock": "La tua taglia è di nuovo disponibile 🎉",
      "email-body": "Corpo dell'email",
      "inventory-threshold-setting": "Impostazione soglia di magazzino",
      "notify-shoppers-when-inventory-reaches-at-least": "Notifica agli acquirenti quando il magazzino raggiunge almeno",
      "threshold-is-required": "La soglia è obbligatoria",
      "threshold-must-be-greater-than-0": "La soglia deve essere maggiore di 0",
      "units": "unità",
      "set-the-minimum-inventory-level-required-to-trigger-notifications": "Imposta il livello minimo di magazzino necessario per attivare le notifiche",
      "choose-a-service": "Scegli un servizio",
      "signing-out": "Disconnessione in corso",
      "signout-of": "Disconnetti da",
      "authenticate": "Autentica",
      "save-settings": "Salva impostazioni",
      "hi-your-is-now-back-in-stock-get-it-before-it-gone": "Ciao {{first_name}}, il tuo {{product_name}} ({{size_variant}}) è ora di nuovo disponibile. Acquistalo prima che finisca di nuovo!",
      "successfully-updated-notification-back-in-stock": "Notifica di rifornimento aggiornata con successo",
      "preferred-language": "Lingua preferita",
      "successfully-updated-your-profile": "Il tuo profilo è stato aggiornato con successo",
      "successfully-updated-mailing-subscription-status": "Stato dell'iscrizione alla newsletter aggiornato con successo!",
      "upgrade-plan": "Aggiorna piano",
      "overview": "Panoramica",
      "billing-cycle": "Ciclo di fatturazione",
      "billing-cycle-resets-at-midnight-on-x-and-the-next-charge-is-on-y": "Il ciclo di fatturazione si azzera a mezzanotte del {{ x }} e il prossimo addebito è previsto per il {{ y }}",
      "billing-information": "Informazioni di fatturazione",
      "update-billing": "Aggiorna fatturazione",
      "monthly-total": "Totale mensile",
      "free-trial-x-days-left": "Prova gratuita - {{ x }} giorni rimanenti",
      "cancel-plan": "Annulla piano",
      "change-plan": "Cambia piano",
      "plan-and-usage": "Piano e utilizzo",
      "tier-offers-in-use": "Offerte di livello in uso",
      "failed-to-cancel-plan": "Impossibile annullare il piano",
      "total-usage": "Utilizzo totale",
      "current-usage-summary": "Riepilogo dell'utilizzo attuale",
      "published-charts": "Tabelle pubblicate",
      "limit-reached": "limite raggiunto",
      "plan-details": "Dettagli del piano",
      "current-plan": "Piano attuale",
      "select-a-reason": "Seleziona un motivo",
      "please-provide-your-reason": "Indica il tuo motivo",
      "chart-preferences": "Preferenze della tabella",
      "skip-picking-dimensions-when-creating-a-new-chart-from-template": "Salta la selezione delle dimensioni durante la creazione di una nuova tabella da un modello",
      "border-color": "Colore del bordo",
      "border-color-is-required": "Il colore del bordo è obbligatorio!",
      "list-of-charts-using-this-image": "Elenco delle tabelle che utilizzano questa immagine",
      "successfully-update-your-profile": "Il tuo profilo è stato aggiornato con successo"
    },
    "analytic": {
      "failed-to-load-statistics": "Impossibile caricare le statistiche",
      "total-chart-views": "Visualizzazioni della tabella",
      "total-add-to-cart": "Aggiunte al carrello",
      "traffic-by-location": "Traffico per posizione",
      "desktop": "Desktop",
      "mobile": "Mobile",
      "size-recommendations": {
        "failed-to-load": "Impossibile caricare l'analisi dei consigli sulle taglie",
        "total-suggestions-title": "Suggerimenti dati",
        "conversion-title": "Conversione",
        "customers-proceeded": "Clienti che hanno proseguito con il suggerimento",
        "of-x-suggestions": "su {{count}} suggerimenti",
        "most-suggested-title": "Prodotto e variante più suggeriti",
        "suggestions-count": "{{count}} suggerimenti",
        "most-common-profile-title": "Profilo più comune",
        "average-profile-title": "Profilo medio",
        "gender": "Genere",
        "age-group": "Fascia d'età",
        "height": "Altezza",
        "weight": "Peso",
        "size-recommended": "Taglia consigliata",
        "graph-suggestions": "Suggerimenti",
        "graph-proceed": "Procedi",
        "source-all": "Tutti",
        "source-chart": "Tabella taglie",
        "source-table-chart": "Tabella a griglia"
      },
      "chart-views": {
        "failed-to-load": "Impossibile caricare le visualizzazioni della tabella",
        "device-types": "Tipi di dispositivo",
        "most-viewed-chart": "Tabella più visualizzata",
        "most-viewed-product": "Prodotto più visualizzato",
        "views-count": "{{ count }} visualizzazioni",
        "view-at": "Visualizzato il",
        "location": "Posizione",
        "graph-label": "Visualizzazioni"
      },
      "add-to-cart": {
        "failed-to-load": "Impossibile caricare l'analisi delle aggiunte al carrello",
        "estimated-revenue": "Valore stimato influenzato",
        "conversion-title": "Conversione da visualizzazione tabella → aggiunta al carrello",
        "most": "Più aggiunte al carrello",
        "adds-count": "{{count}} aggiunte al carrello",
        "added-at": "Aggiunto il",
        "graph-label": "Aggiunte al carrello",
        "views-dataset-label": "Visualizzazioni",
        "add-to-cart-dataset-label": "Aggiungi al carrello"
      },
      "stock-notifications": {
        "failed-to-load": "Impossibile caricare l'analisi delle notifiche di magazzino",
        "failed-to-load-table": "Impossibile caricare la tabella delle notifiche di magazzino",
        "total-subscriptions": "Iscrizioni",
        "total-notifications-sent": "Notifiche inviate",
        "delivery-rate": "Tasso di consegna",
        "opened-of-notified": "{{ opened }} aperte / {{ notified }} notificate",
        "most-subscribed": "Più iscritto",
        "subscriptions-count": "{{ count }} iscrizioni",
        "latest-subscribed": "Ultima iscrizione",
        "subscribed-at": "Iscritto il: {{ date }}",
        "longest-waiting": "Attesa più lunga per il rifornimento",
        "waiting-days": "In attesa da: {{ days }} giorni",
        "waiting-since": "(dal {{ date }})",
        "subscriptions": "Iscrizioni",
        "notifications-sent": "Notifiche inviate",
        "opened": "Aperte",
        "at": "Il",
        "graph-label": "Iscrizioni"
      },
      "paid-gate": {
        "unlock-message": "Sblocca l'analisi avanzata per visualizzare i dati completi e prendere decisioni migliori.",
        "upgrade": "Aggiorna",
        "failed-to-fetch-plans": "Impossibile recuperare i piani"
      },
      "buy-now": {
        "failed-to-load": "Impossibile caricare l'analisi degli acquisti ora",
        "total": "Acquisti ora",
        "estimated-revenue": "Valore stimato influenzato",
        "conversion-title": "Conversione da visualizzazione tabella → acquista ora",
        "most": "Prodotto più acquistato con Acquista ora",
        "buys-count": "{{count}} acquisti ora",
        "graph-label": "Acquisti ora",
        "views-dataset-label": "Visualizzazioni",
        "buy-now-dataset-label": "Acquista ora",
        "clicked-at": "Cliccato il"
      },
      "overview": {
        "funnel-title": "Dove hanno portato le visualizzazioni delle tabelle",
        "no-views-title": "Nessuna visualizzazione della tabella in questo periodo",
        "no-views-hint": "Le tabelle taglie compaiono nelle pagine prodotto una volta pubblicate e assegnate ai prodotti.",
        "chart-views-caption": "Acquirenti che hanno aperto una tabella taglie",
        "baseline-caption": "Tutto ciò che segue è misurato su queste visualizzazioni",
        "of-views": "su {{ count }} visualizzazioni",
        "not-in-funnel": "Fuori dal funnel della tabella"
      },
      "preview": {
        "title": "Ancora nessun dato — questa è un’anteprima",
        "message": "I dati qui sotto sono di esempio e mostrano come apparirà questa pagina quando gli acquirenti inizieranno a usare le tue tabelle taglie."
      }
    },
    "plans": {
      "popular-plan": "Piano popolare",
      "try-now": "Prova ora",
      "activated": "Attivato",
      "contact-sales": "Contatta il team vendite",
      "try-free-for-1-month": "Prova gratis per 1 mese",
      "activate": "Attiva",
      "what-included": "Cosa è incluso?",
      "choose-the-plan-that-fits-your-business-needs": "Scegli il piano che si adatta alle esigenze della tua attività",
      "whether-youre-just-starting-out-or-looking-for-a-robust-sizing-solution-weve-got-a-plan-thats-right-for-you": "Che tu stia appena iniziando o stia cercando una soluzione di taglie solida, abbiamo un piano adatto a te.",
      "monthly": "Mensile",
      "annually": "Annuale",
      "compare-plan-features": "Confronta le funzionalità dei piani",
      "compare-all-plan-features": "Confronta tutte le funzionalità dei piani",
      "feature-usages": "Utilizzi",
      "feature-analytics": "Analisi",
      "feature-support": "Assistenza",
      "feature-integration": "Integrazione",
      "feature-branding": "Branding",
      "feature-api-access": "Accesso API",
      "feature-stock-notifications": "Notifiche di magazzino",
      "feature-published-conversion-charts": "Tabelle di conversione pubblicate",
      "feature-advanced-variant-mapping": "Mappatura avanzata delle varianti",
      "failed-to-fetch-plans": "Impossibile recuperare i piani",
      "failed-to-activate-plan": "Impossibile attivare il piano",
      "contact": {
        "title": "Contatta il team vendite",
        "subtitle": "Raccontaci del tuo negozio e di cosa hai bisogno. Il nostro team ti risponderà via email.",
        "message-placeholder": "Come possiamo aiutare la tua attività?",
        "send": "Invia messaggio",
        "success": "Grazie! Il tuo messaggio è stato inviato. Il nostro team ti contatterà a breve.",
        "first-name-required": "Il nome è obbligatorio",
        "last-name-required": "Il cognome è obbligatorio",
        "email-required": "L'email è obbligatoria",
        "email-invalid": "L'email non è valida",
        "message-required": "Il messaggio è obbligatorio"
      },
      "invite": {
        "title": "Completa il tuo abbonamento",
        "your-plan": "Il tuo piano",
        "order-summary": "Riepilogo dell'ordine",
        "billed-every-30-days": "Fatturato ogni 30 giorni",
        "billed-yearly": "Fatturato annualmente",
        "free-trial": "Prova gratuita di {{days}} giorni",
        "due-today": "Da pagare oggi",
        "then-every-30-days": "Poi {{price}} USD ogni 30 giorni",
        "then-yearly": "Poi {{price}} USD all'anno",
        "continue": "Continua all'approvazione",
        "shopify-note": "Fatturazione tramite Shopify. Approverai l'addebito nella schermata successiva.",
        "switching-note": "Sostituisce il tuo piano attuale dopo la tua approvazione. Shopify applica il credito per il tempo rimanente.",
        "already-on-plan": "Hai già questo piano",
        "unavailable-title": "Questo invito non è più disponibile",
        "unavailable-body": "Il link potrebbe essere scaduto. Contatta chi te lo ha inviato o consulta i piani aperti a tutti i negozi.",
        "see-plans": "Vedi i piani",
        "failed-title": "Impossibile caricare questo piano",
        "failed-body": "Controlla la connessione e ricarica la pagina."
      }
    },
    "auth": {
      "signin": {
        "please-sign-in": "Effettua l'accesso",
        "email-is-required": "L'email è obbligatoria",
        "invalid-email-address": "Indirizzo email non valido",
        "password-is-required": "La password è obbligatoria",
        "sign-in": "Accedi",
        "reset-password": "Reimposta password",
        "generic-error": "Si è verificato un errore durante il processo! Riprova più tardi."
      }
    },
    "admin": {
      "reports": {
        "title": "Report",
        "chart-views": {
          "title": "Visualizzazioni tabella",
          "description": "Scopri quante volte gli acquirenti hanno aperto la tabella taglie, a livello globale in tutti i negozi.",
          "failed-to-load": "Impossibile caricare il report delle visualizzazioni tabella",
          "total-views": "Visualizzazioni della tabella",
          "most-viewed-chart": "Tabella più visualizzata",
          "most-viewed-product": "Prodotto più visualizzato",
          "views-count": "{{ count }} visualizzazioni",
          "traffic-by-location": "Traffico per posizione",
          "device-types": "Tipi di dispositivo",
          "desktop": "Desktop",
          "mobile": "Mobile",
          "top-stores": "Migliori negozi",
          "no-top-stores": "Ancora nessun dato sui negozi",
          "graph-label": "Visualizzazioni",
          "view-at": "Visualizzato il",
          "location": "Posizione"
        },
        "add-to-cart": {
          "title": "Aggiungi al carrello",
          "description": "Scopri come la tabella taglie influisce sugli eventi di aggiunta al carrello, a livello globale in tutti i negozi.",
          "failed-to-load": "Impossibile caricare il report delle aggiunte al carrello",
          "total-add-to-cart": "Aggiunte al carrello",
          "conversion-title": "Conversione da visualizzazione tabella → aggiunta al carrello",
          "most": "Più aggiunte al carrello",
          "adds-count": "{{ count }} aggiunte al carrello",
          "top-stores": "Migliori negozi",
          "no-top-stores": "Ancora nessun dato sui negozi",
          "graph-label": "Aggiunte al carrello",
          "views-dataset-label": "Visualizzazioni",
          "add-to-cart-dataset-label": "Aggiungi al carrello",
          "added-at": "Aggiunto il"
        },
        "buy-now": {
          "title": "Acquista ora",
          "description": "Scopri come la tabella taglie influisce sugli eventi di acquisto ora, a livello globale in tutti i negozi.",
          "failed-to-load": "Impossibile caricare il report degli acquisti ora",
          "total-buy-now": "Acquisti ora",
          "conversion-title": "Conversione da visualizzazione tabella → acquista ora",
          "most": "Prodotto più acquistato con Acquista ora",
          "buys-count": "{{ count }} acquisti ora",
          "top-stores": "Migliori negozi",
          "no-top-stores": "Ancora nessun dato sui negozi",
          "graph-label": "Acquisti ora",
          "views-dataset-label": "Visualizzazioni",
          "buy-now-dataset-label": "Acquista ora",
          "clicked-at": "Cliccato il"
        },
        "conversion-funnel": {
          "title": "Conversione tabella a griglia",
          "description": "Scopri dove i negozianti abbandonano quando trasformano una tabella a griglia in una tabella taglie, a livello globale in tutti i negozi.",
          "failed-to-load": "Impossibile caricare il report di conversione della tabella a griglia",
          "total-runs": "Conversioni avviate",
          "runs-breakdown": "{{ converted }} convertite · {{ handedOver }} trasferite",
          "conversion-title": "Avviata → Convertita",
          "handover-rate": "il {{ rate }}% ha proseguito trasferendo i propri prodotti",
          "handover-gap-title": "Convertita, non trasferita",
          "of-converted-runs": "dei tentativi convertiti",
          "handover-gap-description": "Un trasferimento può avvenire giorni dopo, quindi alcuni di questi sono ancora in sospeso piuttosto che abbandonati.",
          "funnel-title": "Canalizzazione di conversione",
          "funnel-note": "Il passaggio dedicato al trasferimento non viene più attivato — ora il banner è il modo in cui i trasferimenti vengono completati, quindi leggi il suo conteggio come il totale dei trasferimenti piuttosto che come una conversione di passaggio.",
          "no-funnel": "Nessun tentativo di conversione in questo intervallo",
          "drop-off": "abbandono",
          "runs-dataset-label": "Tentativi",
          "drop-offs-title": "Dove terminano i tentativi",
          "drop-offs-description": "L'ultima cosa che ha fatto ogni tentativo. I tentativi che terminano con un trasferimento completato — ora registrato tramite il banner — sono terminati con successo.",
          "no-drop-offs": "Nessun tentativo di conversione in questo intervallo",
          "dwell-title": "Tempo prima di uscire",
          "dwell-description": "Registrato solo quando un negoziante abbandona un passaggio, più il tempo trascorso a leggere la revisione prima di confermare.",
          "no-dwell": "Nessun dato temporale in questo intervallo",
          "step": "Passaggio",
          "samples": "Campioni",
          "median": "Mediana",
          "p90": "P90",
          "top-stores": "Migliori negozi",
          "no-top-stores": "Ancora nessun dato sui negozi",
          "graph-label": "Conversioni avviate",
          "started-at": "Avviato il",
          "duration": "Durata",
          "last-step": "Ultimo passaggio",
          "outcome": "Esito",
          "steps": {
            "entry": "Finestra di dialogo aperta",
            "category": "Categoria",
            "mapping": "Mappatura",
            "summary": "Revisione",
            "convert": "Converti",
            "handover": "Trasferimento",
            "banner": "Banner"
          },
          "actions": {
            "viewed": "visualizzato",
            "completed": "completato",
            "skipped": "saltato",
            "back": "tornato indietro",
            "abandoned": "abbandonato",
            "failed": "fallito",
            "customize_clicked": "personalizza cliccato",
            "dismissed": "ignorato"
          },
          "outcomes": {
            "handed-over": "Trasferita",
            "converted": "Solo convertita",
            "failed": "Fallita",
            "abandoned": "Abbandonata",
            "in-progress": "In corso"
          }
        }
      },
      "delete-category": "Elimina categoria",
      "do-you-want-to-delete-selected-categories": "Vuoi eliminare le categorie selezionate?",
      "global-categories-are-shared-by-every-store": "Le categorie globali sono condivise da tutti i negozi — eliminandone una si influisce su tutti. Questa azione non può essere annullata.",
      "successfully-deleted-category": "Categoria eliminata con successo",
      "average-cost-per-recommendation": "Costo medio per raccomandazione",
      "failed-to-load-recommendations-average-cost": "Impossibile caricare il costo medio delle raccomandazioni",
      "most-expensive-extract": "Estrazione più costosa",
      "most-expensive-recommendation": "Raccomandazione più costosa",
      "total-recommendation-cost": "Costo totale delle raccomandazioni",
      "total-size-recommendation": "Raccomandazioni sulle taglie",
      "total-sheet-extract": "Estrazioni dal foglio",
      "new-category": "Nuova categoria",
      "category-created-unlisted-hint": "La categoria è creata come non elencata. Aggiungi un'immagine e le misure prima di pubblicarla nei negozi.",
      "category-created-successfully": "Categoria creata con successo!",
      "category-search-placeholder": "Nome immagine, nome negozio...",
      "dimension-search-placeholder": "Nome dimensione, nome negozio...",
      "category-not-found": "Categoria non trovata",
      "sub-categories-variants": "Sottocategorie/varianti:",
      "add-sub-category-variant": "Aggiungi sottocategoria/variante:",
      "from-existing": "Da esistente",
      "create-a-new": "Creane una nuova",
      "sub-category-removed": "Sottocategoria rimossa!",
      "remove-sub-category": "Rimuovi sottocategoria",
      "remove-sub-category-confirm": "Rimuovere {{ x }} da questa categoria? Rimarrà disponibile come categoria di primo livello.",
      "update-category": "Aggiorna categoria",
      "published-category-hint": "Una categoria pubblicata è visibile a tutti i negozi. Le categorie non elencate rimangono nascoste.",
      "category-updated-successfully": "Categoria aggiornata con successo!",
      "uninstalled": "Disinstallata",
      "inactive": "Inattivo",
      "install-at": "Installato il",
      "total-chart-views": "Visualizzazioni della tabella",
      "chart-view-at": "Visualizzazione tabella il",
      "store-id": "ID negozio",
      "successfully-deleted-clients": "Clienti eliminati con successo!",
      "session-replay": "Replay della sessione",
      "watch-on-amplitude": "Guarda su Amplitude",
      "shopify-app": "App Shopify",
      "shops-online-store": "Negozio online del negozio",
      "no-more-events-to-load": "Nessun altro evento da caricare!",
      "failed-to-fetch-events": "Impossibile recuperare gli eventi!",
      "info": "Info",
      "store-info": "Informazioni sul negozio",
      "days-ago": "{{ x }} giorni fa",
      "contact-email": "Email di contatto",
      "store-url": "URL del negozio",
      "activities": "Attività",
      "insights": "Approfondimenti",
      "subscriptions": "Iscrizioni",
      "failed-to-fetch-client-info": "Impossibile recuperare le informazioni sul cliente!",
      "failed-to-load-add-to-cart-analytics": "Impossibile caricare l'analisi delle aggiunte al carrello",
      "failed-to-load-buy-now-analytics": "Impossibile caricare l'analisi degli acquisti ora",
      "failed-to-load-chart-views": "Impossibile caricare le visualizzazioni della tabella",
      "failed-to-load-size-recommendations-analytics": "Impossibile caricare l'analisi dei consigli sulle taglie",
      "failed-to-load-stock-notifications-analytics": "Impossibile caricare l'analisi delle notifiche di magazzino",
      "failed-to-load-stock-notifications-table": "Impossibile caricare la tabella delle notifiche di magazzino",
      "chart-views": "Visualizzazioni tabella",
      "add-to-cart": "Aggiungi al carrello",
      "buy-now": "Acquista ora",
      "size-recommendations": "Consigli sulle taglie",
      "stock-notifications": "Notifiche di magazzino",
      "change-details": "Modifica dettagli",
      "plan-subscription-details": "Dettagli dell'abbonamento al piano",
      "ai-size-recommendation-limit": "Limite consigli IA sulle taglie",
      "ai-size-recommendation-limit-required": "Il limite dei consigli IA sulle taglie è obbligatorio!",
      "minimum-limit-is-0": "Il limite minimo è 0!",
      "unlimited": "Illimitato",
      "chart-limit-drafts-hint": "Contano solo le tabelle pubblicate. Le bozze sono illimitate.",
      "chart-limit-required": "Il limite di tabelle è obbligatorio!",
      "chart-limit-whole-number": "Il limite deve essere un numero intero!",
      "stock-notification-limit": "Limite notifiche di magazzino",
      "stock-notification-limit-required": "Il limite delle notifiche di magazzino è obbligatorio!",
      "published-size-chart-limit": "Limite di tabelle taglie pubblicate",
      "published-table-chart-limit": "Limite di tabelle a griglia pubblicate",
      "analytic": "Analisi",
      "full-suite": "Suite completa",
      "select-a-subscription-plan": "Seleziona un piano di abbonamento",
      "failed-to-fetch-plans": "Impossibile recuperare i piani!",
      "new-plan": "Nuovo piano",
      "failed-to-assign-plan-subscription-to-client": "Impossibile assegnare l'abbonamento al piano al cliente!",
      "ai-size-recommendation": "Consiglio IA sulle taglie",
      "stock-notification": "Notifica di magazzino",
      "published-size-charts": "Tabelle taglie pubblicate",
      "published-table-charts": "Tabelle a griglia pubblicate",
      "analytic-access": "Accesso all'analisi",
      "activated-at": "Attivato il",
      "usages": "Utilizzi",
      "failed-to-fetch-client-plan-subscription": "Impossibile recuperare l'abbonamento al piano del cliente!",
      "advanced-variant-mapping": "Mappatura avanzata delle varianti",
      "advanced-variant-mapping-description": "Le tabelle usano le proprie taglie su ogni prodotto assegnato e Aggiungi al carrello sceglie la variante di prodotto corrispondente. Se disattivata, le taglie di una tabella devono corrispondere esattamente ai nomi delle varianti di ogni prodotto.",
      "advanced-variant-mapping-counts": "{{ total }} tabelle · {{ x }} con mappatura avanzata delle varianti",
      "advanced-variant-mapping-drift": "{{ x }} tabelle non corrispondono a questa impostazione.",
      "advanced-variant-mapping-repair": "Ripara",
      "turn-on-advanced-variant-mapping": "Attivare la mappatura avanzata delle varianti?",
      "turn-off-advanced-variant-mapping": "Disattivare la mappatura avanzata delle varianti?",
      "advanced-variant-mapping-on-body": "Tutte le {{ x }} tabelle di questo cliente passano subito alla nuova modalità, e anche le nuove tabelle la useranno. Le misure non vengono modificate e puoi disattivarla di nuovo.",
      "advanced-variant-mapping-off-body": "Tutte le {{ x }} tabelle di questo cliente tornano alla corrispondenza esatta dei nomi delle varianti. Le tabelle le cui taglie sono state rinominate mentre era attiva (ad es. \"Blue / S\" in \"S\") mostreranno misure vuote sui prodotti i cui nomi delle varianti non corrispondono più.",
      "turn-on": "Attiva",
      "turn-off": "Disattiva",
      "failed-to-fetch-advanced-variant-mapping": "Impossibile recuperare la mappatura avanzata delle varianti!",
      "failed-to-update-advanced-variant-mapping": "Impossibile aggiornare la mappatura avanzata delle varianti!",
      "plan-used-as-free-trial": "Piano utilizzato come prova gratuita per i clienti appena registrati",
      "x-usages": "{{ x }} utilizzi",
      "successfully-updated-configuration-value": "Valore di configurazione aggiornato con successo",
      "only-authorized-personnel-hint": "Solo il personale autorizzato può accedere e modificare la configurazione globale dell'applicazione!",
      "password-is-required": "La password è obbligatoria",
      "authorize": "Autorizza",
      "1-month": "1 mese",
      "3-months": "3 mesi",
      "6-months": "6 mesi",
      "1-year": "1 anno",
      "failed-to-load-costs": "Impossibile caricare i costi",
      "failed-to-load-total-recommendations": "Impossibile caricare il totale delle raccomandazioni",
      "archived": "Archiviato",
      "billing-interval": "Intervallo di fatturazione",
      "plan-information": "Informazioni sul piano",
      "name-is-required": "Il nome è obbligatorio!",
      "features": "Funzionalità",
      "stock-notification-recommendation-limit": "Limite raccomandazioni notifiche di magazzino",
      "popular": "Popolare",
      "allow-trial": "Consenti prova",
      "interval": "Intervallo",
      "interval-is-required": "L'intervallo è obbligatorio!",
      "price-is-required": "Il prezzo è obbligatorio!",
      "minimum-price-is-0": "Il prezzo minimo è 0!",
      "discounted-from": "Scontato da",
      "description": "Descrizione",
      "description-is-required": "La descrizione è obbligatoria!",
      "selling-points": "Punti di forza",
      "selling-point-x": "Punto di forza {{ x }}",
      "selling-point-is-required": "Il punto di forza è obbligatorio!",
      "analytic-is-required": "L'analisi è obbligatoria!",
      "support": "Supporto",
      "support-is-required": "Il supporto è obbligatorio!",
      "status-is-required": "Lo stato è obbligatorio!",
      "manage-preset-dimensions": "Gestisci le dimensioni preimpostate, i loro sinonimi di rilevamento e le traduzioni.",
      "detection-synonyms": "Sinonimi di rilevamento",
      "add-synonym-placeholder": "Digita un sinonimo e premi Invio",
      "translations": "Traduzioni",
      "missing-translation": "Traduzione mancante",
      "new-dimension": "Nuova dimensione",
      "edit-dimension": "Modifica dimensione",
      "delete-preset-dimension": "Elimina dimensione preimpostata",
      "do-you-want-to-delete-this-preset-dimension": "Vuoi eliminare \"{{ name }}\"?",
      "preset-dimensions-are-shared-by-every-store": "Le dimensioni preimpostate sono condivise da tutti i negozi — eliminandone una la si rimuove da tutte le categorie che la utilizzano. Questa azione non può essere annullata.",
      "successfully-created-dimension": "Dimensione creata con successo!",
      "successfully-updated-dimension": "Dimensione aggiornata con successo!",
      "successfully-deleted-dimension": "Dimensione eliminata con successo!",
      "ai-provider-for-file-imports": "Fornitore di IA per l'importazione di file",
      "no-api-key-configured-in-this-environment": "Nessuna chiave API configurata in questo ambiente",
      "ai-provider-saved-applies-to-new-imports": "Fornitore di IA salvato. Si applica alle nuove importazioni; quelle già in corso mantengono il loro fornitore.",
      "ai-provider-for-size-recommendations": "Fornitore di IA per i consigli sulle taglie",
      "ai-provider-saved-applies-to-next-recommendation": "Fornitore di IA salvato. Si applica dal prossimo consiglio sulle taglie.",
      "size-recommendation-provider-hint": "Usato per i consigli IA sulle taglie per gli acquirenti. Separato dall'importazione di file.",
      "ai-measurement-import": "Importazione misure con IA",
      "name-admin-only": "Nome (solo admin)",
      "name-admin-only-hint": "L'app riconosce i piani Free ed Enterprise da questo nome, quindi non rinominarli.",
      "display-name": "Nome visualizzato",
      "display-name-hint": "Mostrato ai commercianti nella pagina dei piani, nelle pagine di fatturazione e nell'addebito Shopify. Lascia vuoto per usare il nome.",
      "display-name-too-long": "Il nome visualizzato può contenere al massimo 40 caratteri!",
      "availability": "Disponibilità",
      "available-from-utc": "Disponibile dal (UTC)",
      "available-from-hint": "Lascia vuoto per offrirlo non appena è attivo.",
      "expires-at-utc": "Scade il (UTC)",
      "expires-at-required": "Imposta quando scade!",
      "window-order": "Deve diventare disponibile prima di scadere!",
      "your-time": "La tua ora: {{time}}",
      "availability-always": "Sempre offerto",
      "availability-scheduled": "Programmato: non ancora offerto",
      "availability-live": "Attivo: offerto ora",
      "availability-ended": "Terminato: non più offerto",
      "promo-plan": "Piano promozionale",
      "replaces-plan": "Sostituisce",
      "replaces-plan-none": "Niente (un piano normale)",
      "replaces-plan-hint": "Finché questo piano è offerto, i commercianti lo vedono al posto del piano che sostituisce.",
      "campaign": "Campagna",
      "campaign-required": "Scegli la campagna a cui appartiene questo piano promozionale!",
      "merchants-see": "I commercianti vedono",
      "replaces-x": "sostituisce {{x}}",
      "archiving-hint": "L'archiviazione nasconde un piano solo ai nuovi abbonati. Gli abbonati attuali lo mantengono.",
      "duplicate-as-promo-plan": "Duplica come piano promozionale",
      "help-articles": {
        "topic": "Argomento",
        "all-topics": "Tutti gli argomenti",
        "topics": {
          "getting-started": "Primi passi",
          "size-charts": "Tabelle taglie",
          "table-charts": "Tabelle a griglia",
          "assigning-products": "Assegnazione ai prodotti",
          "storefront-display": "Visualizzazione nel negozio",
          "chart-import": "Importazione tabelle",
          "size-recommendations": "Consigli sulla taglia",
          "plans-billing": "Piani e fatturazione",
          "troubleshooting": "Risoluzione dei problemi"
        },
        "new-article": "Nuovo articolo di aiuto",
        "slug": "Slug",
        "slug-hint": "L'indirizzo dell'articolo nel centro assistenza: /help/il-tuo-slug. Modificarlo rende non validi i link al vecchio indirizzo.",
        "slug-invalid": "Usa lettere minuscole, numeri e trattini singoli.",
        "slug-taken": "Un altro articolo usa già questo slug.",
        "title-is-required": "Il titolo è obbligatorio",
        "summary": "Riepilogo",
        "summary-hint": "Una riga. L'assistente di supporto sceglie gli articoli in base al riepilogo.",
        "summary-is-required": "Il riepilogo è obbligatorio",
        "order": "Ordine",
        "body-hint": "Markdown. Collega un altro articolo con [testo](/help/il-suo-slug).",
        "insert-image": "Inserisci immagine",
        "image-upload-failed": "Impossibile caricare l'immagine.",
        "view-on-help-centre": "Visualizza nel centro assistenza",
        "broken-links": "Pubblicato, ma questi link portano ad articoli che non esistono o non sono pubblicati:",
        "article-saved": "Articolo salvato",
        "article-published": "Articolo pubblicato",
        "article-unpublished": "Pubblicazione dell'articolo annullata",
        "article-deleted": "Articolo eliminato",
        "delete-article": "Elimina articolo",
        "delete-article-prompt": "Eliminare «{{title}}»? Scompare subito dal centro assistenza e dall'assistente di supporto.",
        "load-failed": "Impossibile caricare l'articolo.",
        "export": "Esporta",
        "import": "Importa",
        "export-failed": "Impossibile esportare gli articoli.",
        "import-title": "Importa articoli di aiuto",
        "import-checking": "Controllo del file…",
        "import-preview": "{{file}} creerà {{created}} e aggiornerà {{updated}} articoli, con {{images}} immagini. Gli articoli non presenti nel file restano invariati.",
        "import-invalid": "Questo file non può essere importato:",
        "imported": "Importati: {{created}} creati, {{updated}} aggiornati."
      },
      "invite-only": "Solo su invito",
      "invite-only-hint": "Nascosto nella pagina dei piani. Chiunque abbia il link può abbonarsi. Non può essere modificato dopo la creazione del piano.",
      "invite-only-price-required": "Un piano solo su invito deve avere un prezzo superiore a 0",
      "copy-invite-link": "Copia link di invito",
      "invite-link-copied": "Link di invito copiato",
      "invite-link-copy-failed": "Impossibile copiare il link di invito"
    }
  },
  "search": {
    "no-result-found": "Nessun risultato trovato!",
    "type": {
      "product": "Prodotto",
      "variant": "Variante",
      "client": "Cliente"
    },
    "show-less": "Mostra meno",
    "show-full": "Mostra tutto",
    "search-x-by-full-name": "Cerca {{ x }} per nome completo",
    "load-more...": "Carica altro..."
  },
  "privacy-policy": "Informativa sulla privacy",
  "contact-us": "Contattaci",
  "notification": {
    "notification": "Notifica",
    "mark-all-as-read": "Segna tutto come letto",
    "compose": "Componi notifica",
    "title-required": "Il titolo è obbligatorio!",
    "message-required": "Il messaggio è obbligatorio!",
    "sent-to-all-clients": "Una notifica è stata inviata a tutti i clienti"
  },
  "table": {
    "sort": "Ordina",
    "sort-by": "Ordina per",
    "oldest-first": "Prima i più vecchi",
    "newest-first": "Prima i più recenti",
    "a-z": "Dalla A alla Z",
    "z-a": "Dalla Z alla A",
    "lowest-first": "Dal più basso",
    "highest-first": "Dal più alto",
    "no-data-found": "Nessun dato trovato"
  },
  "grading": {
    "grading-configuration": "Configurazione della gradazione",
    "base-size": "Taglia base",
    "enter-your-grading-allowances": "Inserisci le tue tolleranze di gradazione",
    "base": "Base"
  },
  "chart": {
    "image-nav-previous": "Immagine precedente",
    "image-nav-next": "Immagine successiva",
    "image-nav-position": "{{current}} / {{total}}",
    "image-add-slot-placeholder": "Aggiungi un'altra immagine",
    "image-add-slot-formats": "Formati accettati: .png, .jpeg, .jpg",
    "image-cap-reached": "Hai raggiunto il numero massimo di immagini per questa categoria.",
    "image-upload-failed": "Non è stato possibile caricare l'immagine. Riprova.",
    "image-svg-not-accepted": "Qui non sono accettati file SVG.",
    "image-delete": "Elimina immagine",
    "image-move-left": "Sposta immagine a sinistra",
    "image-move-right": "Sposta immagine a destra",
    "image-delete-confirm-title": "Eliminare questa immagine?",
    "image-delete-confirm-body": "Questa immagine verrà rimossa definitivamente e non potrà essere recuperata.",
    "image-delete-confirm-cancel": "Annulla",
    "image-delete-confirm-action": "Elimina immagine",
    "image-delete-last-tooltip": "Una categoria deve avere almeno un'immagine.",
    "image-customize-first-tooltip": "Personalizza prima questa categoria per gestirne le immagini.",
    "image-delete-failed": "Non è stato possibile eliminare l'immagine. Riprova.",
    "image-reorder-failed": "Non è stato possibile riordinare le immagini. Riprova.",
    "do-you-want-to-delete-this-chart": "Vuoi eliminare questa tabella?",
    "unnamed-chart": "Tabella senza nome",
    "get-size-chart-permalink": "Ottieni il link permanente della tabella taglie",
    "chart-external-link-is-copied-to-clipboard": "Il link esterno della tabella è stato copiato negli appunti",
    "failed-to-duplicate-chart": "Impossibile duplicare la tabella",
    "failed-to-create-chart": "Impossibile creare la tabella",
    "add-new-layout-blocks": "Aggiungi nuovi blocchi di layout",
    "click-on-these-layout-types-and-add-to-the-size-chart": "Clicca su questi tipi di layout e aggiungili alla tabella taglie",
    "rename-chart": "Rinomina tabella",
    "chart-renamed-successfully": "Tabella rinominata con successo",
    "failed-to-rename-chart": "Impossibile rinominare la tabella",
    "preview": "Anteprima",
    "model-info": "Informazioni sul modello",
    "model-details": "Dettagli del modello",
    "help-shoppers-by-showing-the-model-height-and-size": "Aiuta gli acquirenti mostrando l'altezza e la taglia del modello",
    "model-name": "Nome del modello",
    "enter-model-name": "Inserisci il nome del modello",
    "model-height": "Altezza del modello",
    "please-enter-valid-number": "Inserisci un numero valido",
    "size-worn": "Taglia indossata",
    "show-variants-by": "Mostra varianti per",
    "add-options-like-size-or-color": "Aggiungi opzioni come taglia o colore",
    "select-existing-chart": "Seleziona tabella esistente",
    "search-charts": "Cerca tabelle per nome",
    "no-charts-found": "Nessuna tabella trovata",
    "search-dimensions": "Cerca dimensioni",
    "no-dimensions-found": "Nessuna dimensione trovata",
    "add-a-new-size-chart": "Aggiungi una nuova tabella taglie",
    "this-product-is-using-table-chart": "Questo prodotto sta utilizzando una tabella a griglia",
    "update-your-size-chart": "Aggiorna la tua tabella taglie",
    "create-your-size-chart": "Crea la tua tabella taglie",
    "use-a-template": "Usa un modello",
    "use-template-variants": "Usa modello e varianti",
    "pick-a-method-to-get-started": "Scegli un metodo per iniziare",
    "select-an-existing-chart": "Seleziona una tabella esistente",
    "image-set-annotation-panel": "Pannello di annotazione del set di immagini",
    "measure-guide": "Guida alle misure...",
    "drag-drop-to-mark-measurement-bubble": "Trascina e rilascia per contrassegnare il punto di misurazione",
    "are-you-sure-you-want-to-delete-all-measurements": "Sei sicuro di voler eliminare tutte le misure?",
    "accepts-png-jpeg-jpg-svg": "Accetta .png, .jpeg, .jpg, .svg",
    "this-name-will-appear-in": "Questo nome apparirà in",
    "image-set": "set di immagini",
    "added-measurements": "Misure aggiunte",
    "no-measurements-added-yet": "Nessuna misura ancora aggiunta",
    "drag-and-drop-a-chip-to-edit-its-line-on-the-canvas": "Trascina un chip per modificare la sua linea sulla tela",
    "after-adding-a-measurement-drag-and-drop-it-from-the-section-above-onto-the-image": "Dopo aver aggiunto una misura, trascinala dalla sezione 'Misure aggiunte' sopra sull'immagine",
    "across-shoulder-front-rise-belt": "Larghezza spalle, cavallo anteriore, cintura, ...",
    "create-measurement": "Crea misura",
    "examples-across-shoulder-front-rise-cuff-width": "Esempi: 'Larghezza spalle', 'Cavallo anteriore', 'Larghezza polsino'",
    "delete-anotation-set": "Elimina set di annotazioni",
    "this-will-remove-all-measurements-from-this-image": "Questo rimuoverà tutte le misure da questa immagine",
    "measurement-name": "Nome della misura",
    "size-recommender": "Consulente taglie",
    "size-recommender-history": "Consigli recenti",
    "your-buyer-personal-fitting-assistant-that-instantly-suggests-the-perfect-size-every-time": "L'assistente personale di vestibilità del tuo acquirente che suggerisce istantaneamente la taglia perfetta, ogni volta",
    "stretch-factor": "Fattore di elasticità",
    "how-stretchy-is-the-fabric-a-rough-estimate-is-enough-if-unsure-then-leave-at-10": "Quanto è elastico il tessuto? Una stima approssimativa è sufficiente. Se non sei sicuro, lascialo al 10%",
    "easing": "Agio",
    "wearing-ease-is-the-amount-added-to-a-person-body-measurements-so-one-can-move-in-a-garment": "L'agio è la quantità aggiunta alle misure corporee di una persona in modo da potersi muovere in un capo di abbigliamento.",
    "set-default": "Imposta come predefinito",
    "suggested": "Suggerito",
    "assign-chart": "Assegna tabella",
    "your-chart-has-not-been-assigned-to-any-product-yet": "La tua tabella non è ancora stata assegnata a nessun prodotto",
    "assign-your-chart-so-it-will-appear-on-product-pages": "Assegna la tua tabella in modo che appaia nelle pagine dei prodotti",
    "assign-it-to-a-product": "Assegnala a un prodotto",
    "select-the-products-or-collections-where-you-want-your-size-chart-to-appear": "Seleziona i prodotti o le collezioni in cui vuoi che appaia la tua tabella taglie",
    "x-matched-y": "{{ x }} corrisponde a {{ y }}",
    "overwritting-x-products": "(sovrascrivendo {{ x }} prodotti)",
    "calculating...": "Calcolo in corso...",
    "select-product-or-collection": "Seleziona prodotto o collezione",
    "remove-all": "Rimuovi tutto",
    "are-you-sure-you-want-to-remove-all-conditions": "Sei sicuro di voler rimuovere tutte le condizioni?",
    "list-of-matched-products": "Elenco dei prodotti corrispondenti",
    "give-your-size-chart-a-name": "Assegna un nome alla tua tabella taglie",
    "this-name-is-only-used-internally-to-help-you-organise-your-charts-customers-wont-see-it": "Questo nome è utilizzato solo internamente per aiutarti a organizzare le tue tabelle. I clienti non lo vedranno.",
    "eg-mens-t-shirt-size-chart": "es. Tabella taglie t-shirt uomo",
    "add-text-block": "Aggiungi blocco di testo",
    "product-image-optional": "Immagine del prodotto (opzionale)",
    "add-layout-block": "Aggiungi blocco di layout",
    "move-this-block-up": "Sposta questo blocco in alto",
    "move-this-block-down": "Sposta questo blocco in basso",
    "clear-this-image": "Cancella questa immagine",
    "align-this-image": "Allinea questa immagine",
    "clear-this-video": "Cancella questo video",
    "apply-grading-to-this-table": "Applica la gradazione a questa tabella",
    "duplicate-this-block-to-below": "Duplica questo blocco sotto",
    "remove-this-block": "Rimuovi questo blocco",
    "upload-an-image": "Carica un'immagine",
    "browse-to-upload": "Sfoglia per caricare",
    "choose-from-our": "Scegli tra i nostri",
    "ready-made-templates": "modelli pronti all'uso",
    "select-a-template": "Seleziona un modello",
    "new-row": "Nuova riga",
    "new-column": "Nuova colonna",
    "add-column-left": "Aggiungi colonna a sinistra",
    "add-column-right": "Aggiungi colonna a destra",
    "move-left": "Sposta a sinistra",
    "move-right": "Sposta a destra",
    "freeze": "Blocca",
    "unfreeze": "Sblocca",
    "delete-column": "Elimina colonna",
    "add-row-above": "Aggiungi riga sopra",
    "add-row-below": "Aggiungi riga sotto",
    "move-up": "Sposta in alto",
    "move-down": "Sposta in basso",
    "delete-row": "Elimina riga",
    "insert-video": "Inserisci video",
    "select-a-video": "Seleziona un video",
    "paste-a-link-to-a-video-here": "Incolla qui un link a un video",
    "webgl-not-supported": "Il tuo browser non supporta WebGL. Attiva il supporto WebGL se stai utilizzando un browser moderno come Chrome, Firefox o Safari.",
    "table-chart-created": "Tabella a griglia creata",
    "name-this-image-set": "Assegna un nome a questo set di immagini",
    "name-your-import": "Assegna un nome alla tua importazione",
    "table-chart-updated": "Tabella a griglia aggiornata",
    "chart-updated": "Tabella aggiornata",
    "use-how-to-measure-block": "Usare il blocco 'Come misurare'? (Opzionale)",
    "a-text-block-under-an-expandable-panel-will-be-added-where-you-can-fill-in-details-for-your-customers-on-how-to-measure-their-measurements": "Verrà aggiunto un blocco di testo sotto un pannello espandibile dove potrai inserire i dettagli per i tuoi clienti su come prendere le loro misure",
    "newest-5-recommendations-given-to-your-customers": "Gli ultimi 5 consigli dati ai tuoi clienti",
    "size-recommended": "Taglia consigliata",
    "view-all-data": "Visualizza tutti i dati",
    "please-select-a-size-worn": "Seleziona una taglia indossata",
    "recommended-for-this-garment-add-or-remove-as-needed": "Consigliato per questo capo, aggiungi o rimuovi secondo necessità",
    "add-more": "Aggiungi altro",
    "add-custom-measurements": "Aggiungi misure personalizzate",
    "skip-this-step-next-time": "Salta questo passaggio la prossima volta",
    "use-unit-conversion": "Usa la conversione delle unità",
    "disabled-by-chart": "Disabilitato dalla tabella",
    "disabled-globally-by-settings": "Disabilitato globalmente dalle impostazioni",
    "hide-unit-conversion-toggle-on-all-charts-appear-on-your-storefront": "Nascondi il selettore di conversione unità su tutte le tabelle presenti nel tuo negozio",
    "assign-products": "Assegna prodotti",
    "select-products-to-assign-to-the-chart": "Seleziona i prodotti da assegnare alla tabella",
    "products-assigned-successfully": "Prodotti assegnati con successo",
    "source-table": "Tabella di origine",
    "root-table": "Tabella principale",
    "table-block": "Tabella",
    "which-axis-holds-the-dimension-data": "Quale asse contiene i dati della dimensione? (Spalla, Vita, ecc.)",
    "columns": "Colonne",
    "rows": "Righe",
    "measurement-unit": "Unità di misura",
    "map-each-line-to-a-dimension": "Mappa ogni riga a una dimensione",
    "ignore": "Ignora",
    "line": "Riga",
    "the-selected-table-has-no-data-to-map": "La tabella selezionata non ha dati da mappare.",
    "tell-us-how-your-table-maps-to-body-dimensions-so-we-can-suggest-a-size": "Dicci come la tua tabella si mappa alle dimensioni corporee in modo da poter suggerire una taglia.",
    "choose-which-table-the-ai-reads-to-suggest-a-size": "Scegli quale tabella l'IA legge per suggerire una taglia.",
    "per-dimension-stretch-and-easing-controls": "Controlli di elasticità e agio per dimensione",
    "jump-to-table": "Vai alla tabella",
    "scroll-to-the-selected-table": "Scorri fino alla tabella selezionata",
    "this-table-is-used-as-your-size-recommendation-data-source": "Questa tabella viene utilizzata come fonte dati per il tuo consiglio sulle taglie",
    "this-table-block-can-not-be-deleted-right-now": "Questo blocco tabella non può essere eliminato al momento"
  },
  "error": {
    "there-was-an-error-while-authenticating-your-store": "Si è verificato un errore durante l'autenticazione del tuo negozio!",
    "click-the-button-below-to-try-again-if-the-issue-persisted-contact-us-for-further-instruction": "Clicca sul pulsante qui sotto per riprovare. Se il problema persiste, contattaci per ulteriori istruzioni.",
    "refresh-the-app": "Aggiorna l'app",
    "error-occured": "Si è verificato un errore!"
  },
  "banner": {
    "add-the-goodchart-size-guide-button-to-your-storefront": "Aggiungi il pulsante della guida taglie Goodchart al tuo negozio",
    "we-ve-detected-you-are-integrating-with-shopify-enable-app-embed-or-add-an-app-block": "Abbiamo rilevato che ti stai integrando con Shopify. Abilita l'incorporamento dell'app per mostrare automaticamente il pulsante della guida taglie su ogni pagina del prodotto, oppure aggiungi un blocco app per posizionarlo in un punto specifico. Hai bisogno di aiuto? Consulta questa <a class=\"underline\" href=\"{{ guide }}\" target=\"_blank\">guida</a>.",
    "enable-app-embed": "Abilita l'incorporamento dell'app",
    "add-app-block": "Aggiungi blocco app",
    "your-new-size-chart-is-ready-to-review": "La tua nuova tabella taglie è pronta per la revisione",
    "look-around-then-hand-the-conversion-over": "Per i tuoi acquirenti non è ancora cambiato nulla — la tua tabella a griglia è ancora quella attiva. Prenditi il tuo tempo per controllare le misure e la guida, poi trasferisci la conversione quando sembra tutto corretto.",
    "about-your-plan-usage": "Informazioni sull'utilizzo del tuo piano",
    "measurements-applied": "Misure applicate",
    "selection-applied-all-variants": "La selezione è stata applicata a tutte le varianti di taglia.",
    "you-have-reached-x-of-ai-size-recommendations-limit": "Hai raggiunto il {{ x }}% del limite dei consigli IA sulle taglie del tuo piano attuale. Tieni presente che qualsiasi utilizzo superiore al 100% sarà addebitato alla tariffa standard.",
    "you-have-reached-x-of-stock-notification-limit": "Hai raggiunto il {{ x }}% del limite delle notifiche di magazzino del tuo piano attuale.",
    "over-usage-cost": "Costo di sovrautilizzo",
    "you-have-exceeded-ai-size-recommendation-limit-pay-to-continue-using-service": "Hai superato il limite dei consigli IA sulle taglie. Procedi a pagare il costo di sovrautilizzo per continuare a usare il servizio.",
    "you-have-exceeded-ai-size-recommendation-limit-pay-to-continue-using-this-feature": "Hai superato il limite dei consigli IA sulle taglie. Procedi a pagare il costo di sovrautilizzo per continuare a usare questa funzione.",
    "n-of-your-table-charts-can-be-upgraded-to-smart-size-charts": "{{count}} delle tue tabelle a griglia possono essere aggiornate a tabelle taglie intelligenti"
  },
  "onboarding": {
    "skip-for-now": "Salta per ora",
    "step-x-of-y": "Passaggio {{ x }} di {{ y }}",
    "select-the-category-that-best-matches-your-product": "Seleziona la categoria che meglio corrisponde al tuo prodotto.",
    "apparel": "Abbigliamento",
    "tops": "Capi superiori",
    "pants": "Pantaloni",
    "dresses": "Vestiti",
    "shoes": "Scarpe",
    "sneakers": "Sneaker",
    "boots": "Stivali",
    "sandals": "Sandali",
    "accessories": "Accessori",
    "belts": "Cinture",
    "bags": "Borse",
    "hats": "Cappelli",
    "other-custom": "Altro/personalizzato",
    "equipment": "Attrezzatura",
    "tool": "Strumento",
    "furniture": "Mobili",
    "upload-any-product-image-and-place-measurements-visually-works-for-apparel-shoes-and-accessories": "Carica un'immagine qualsiasi del prodotto e posiziona le misure visivamente. Funziona per abbigliamento, scarpe e accessori.",
    "table-style-chart": "Tabella in stile griglia",
    "create-a-grid-based-chart-with-rows-and-columns-best-for-detailed-size-specifications": "Crea una tabella basata su griglia con righe e colonne. Ideale per specifiche di taglia dettagliate.",
    "your-size-chart-is-ready": "La tua tabella taglie è pronta",
    "you-can-now-decide-where-this-size-chart-should-appear-in-your-store-you-can-skip-this-step-and-assign-products-later": "Ora puoi decidere dove questa tabella taglie dovrebbe apparire nel tuo negozio. Puoi saltare questo passaggio e assegnare i prodotti in seguito.",
    "apply-this-chart-to-products-now": "Applica questa tabella ai prodotti ora",
    "choose-which-products-should-use-this-size-chart": "Scegli quali prodotti dovrebbero utilizzare questa tabella taglie.",
    "i-ll-do-this-later": "Lo farò più tardi",
    "you-can-assign-or-change-matching-anytime-from-chart-settings": "Puoi assegnare o modificare la corrispondenza in qualsiasi momento dalle impostazioni della tabella.",
    "select-products-to-assign-chart-to": "Seleziona i prodotti a cui assegnare la tabella",
    "apply-this-chart-to-all-products": "Applica questa tabella a tutti i prodotti.",
    "select-products-to-apply-this-chart-to": "Seleziona i prodotti a cui applicare questa tabella.",
    "assigning...": "Assegnazione in corso...",
    "size-chart-created-successfully": "Tabella taglie creata con successo",
    "you-can-assign-products-anytime-from-chart-settings": "Puoi assegnare i prodotti in qualsiasi momento dalle impostazioni della tabella.",
    "view-chart": "Visualizza tabella",
    "go-to-dashboard": "Vai alla dashboard",
    "turn-your-size-chart-into-a-conversion-tool": "Trasforma la tua tabella taglie in uno strumento di conversione",
    "help-shoppers-pick-the-right-size-and-reduce-returns": "Aiuta gli acquirenti a scegliere la taglia giusta e riduci i resi.",
    "setup-takes-about-2-minutes": "La configurazione richiede circa 2 minuti.",
    "choose-how-your-size-chart-looks": "Scegli l'aspetto della tua tabella taglie",
    "other-ways-to-create-a-chart": "Altri modi per creare una tabella",
    "failed-to-proceed-please-try-again": "Impossibile procedere, riprova",
    "this-chart-connects-to-your-shopify-product-and-variants-so-shoppers-can-select-their-size-add-to-cart-or-buy-now-without-leaving-the-chart": "Questa tabella si collega al tuo prodotto e alle varianti Shopify, in modo che gli acquirenti possano selezionare la loro taglia, aggiungere al carrello o acquistare ora senza lasciare la tabella",
    "add-the-size-guide-button-to-your-storefront": "Aggiungi il pulsante della guida taglie al tuo negozio",
    "choose-how-the-goodchart-size-guide-button-should-appear-on-your-product-pages": "Scegli come dovrebbe apparire il pulsante della guida taglie GoodChart nelle pagine dei tuoi prodotti.",
    "enable-app-embed": "Abilita l'incorporamento dell'app",
    "installed": "Installato",
    "automatically-display-the-size-guide-button-on-all-product-pages": "Mostra automaticamente il pulsante della guida taglie su tutte le pagine dei prodotti.",
    "add-app-block-to-product-page": "Aggiungi blocco app alla pagina del prodotto",
    "prefer-to-place-the-button-in-a-specific-spot-on-your-product-page": "Preferisci posizionare il pulsante in un punto specifico della tua pagina prodotto?",
    "place-the-size-guide-button-in-a-specific-spot-on-your-product-page-template": "Posiziona il pulsante della guida taglie in un punto specifico nel modello della tua pagina prodotto.",
    "open": "Apri",
    "check-button-installation": "Controlla installazione pulsante",
    "checking": "Controllo in corso...",
    "great-the-size-guide-button-is-installed-on-your-storefront": "Ottimo! Il pulsante della guida taglie è installato nel tuo negozio.",
    "we-could-not-detect-the-size-guide-button-yet-please-make-sure-you-saved-the-changes-in-the-theme-editor": "Non siamo ancora riusciti a rilevare il pulsante della guida taglie. Assicurati di aver salvato le modifiche nell'editor del tema.",
    "app-block-installed-on-your-product-page": "Blocco app installato nella pagina del tuo prodotto"
  },
  "common": {
    "updated": "Aggiornato",
    "name": "Nome",
    "avatar": "Avatar",
    "category-image": "Immagine categoria",
    "increase": "Aumenta",
    "created": "Creato",
    "email": "Email",
    "password": "Password",
    "yes": "Sì",
    "no": "No",
    "chart": "Tabella",
    "gender": "Genere",
    "height": "Altezza",
    "weight": "Peso",
    "age-group": "Fascia d'età",
    "fit-preference": "Preferenza di vestibilità",
    "score": "Punteggio",
    "table-chart": "Tabella a griglia",
    "draft": "Bozza",
    "active": "Attivo",
    "products": "Prodotti",
    "none": "Nessuno",
    "cancel": "Annulla",
    "retry": "Riprova",
    "delete": "Elimina",
    "export": "Esporta",
    "variant": "Variante",
    "variants": "Varianti",
    "account": "Account",
    "personal": "Personale",
    "appearance": "Aspetto",
    "organization": "Organizzazione",
    "information": "Informazioni",
    "first-name": "Nome",
    "last-name": "Cognome",
    "save": "Salva",
    "pay": "Paga",
    "undo": "Annulla",
    "redo": "Ripeti",
    "newsletter-subscription": "Iscrizione alla newsletter",
    "button": "Pulsante",
    "colour": "Colore",
    "default": "Predefinito",
    "white": "Bianco",
    "light-grey": "Grigio chiaro",
    "soft-beige": "Beige tenue",
    "saving...": "Salvataggio in corso...",
    "all-changes-saved": "Tutte le modifiche sono state salvate",
    "publish": "Pubblica",
    "unpublish": "Annulla pubblicazione",
    "images": "Immagini",
    "charts": "Tabelle",
    "confirm": "Conferma",
    "dimensions": "Dimensioni",
    "new": "Nuovo",
    "missing": "Mancante",
    "editing-x": "Modifica di {{ x }}",
    "back-in-stock": "Di nuovo disponibile",
    "product": "Prodotto",
    "grading": "Gradazione",
    "more-actions": "Altre azioni",
    "table": "Tabella",
    "measurement": "Misura",
    "close": "Chiudi",
    "apply": "Applica",
    "duplicate": "Duplica",
    "add-layout-blocks": "Aggiungi blocchi di layout",
    "text": "Testo",
    "image": "Immagine",
    "video": "Video",
    "new-name": "Nuovo nome",
    "published": "Pubblicato",
    "all": "Tutti",
    "editing": "Modifica in corso",
    "show-more": "Mostra altro",
    "loading": "Caricamento in corso",
    "or": "Oppure",
    "browse-files": "Sfoglia file",
    "edit": "Modifica",
    "customize": "Personalizza",
    "clear": "Cancella",
    "label": "Etichetta",
    "discard-changes": "Scarta modifiche",
    "uploading": "Caricamento in corso...",
    "preset": "Preimpostazione",
    "custom": "Personalizzato",
    "manage": "Gestisci",
    "done": "Fatto",
    "reminder": "Promemoria",
    "collections": "Collezioni",
    "all-products": "Tutti i prodotti",
    "select": "Seleziona",
    "search": "Cerca",
    "select-all": "Seleziona tutto",
    "size-chart": "Tabella taglie",
    "continue": "Continua",
    "back": "Indietro",
    "visual-measurement-builder": "Costruttore visivo delle misure",
    "recommend": "Consiglia",
    "creating...": "Creazione in corso...",
    "syncing": "Sincronizzazione in corso...",
    "preview": "Anteprima",
    "create": "Crea",
    "onboarding": "Onboarding",
    "english": "English",
    "french": "Français",
    "spanish": "Español",
    "czech": "Čeština",
    "danish": "Dansk",
    "german": "Deutsch",
    "italian": "Italiano",
    "dutch": "Olandese",
    "japanese": "Giapponese",
    "off": "Off",
    "basic": "Base",
    "AI": "IA",
    "details": "Dettagli",
    "date": "Data",
    "billing": "Fatturazione",
    "settings": "Impostazioni",
    "log-out": "Esci",
    "plan": "Piano",
    "ai-size-recommendation": "Consiglio IA sulle taglie",
    "recommendations": "Consigli",
    "features": "Funzionalità",
    "stock-notification": "Notifica di magazzino",
    "published-size-charts": "Tabelle taglie pubblicate",
    "published-table-charts": "Tabelle a griglia pubblicate",
    "unlimited": "Illimitato",
    "x-of-y": "{{ x }} di {{ y }}",
    "measurements": "Misure",
    "selected": "Selezionato",
    "select-product": "Seleziona prodotto",
    "price": "Prezzo",
    "title": "Titolo",
    "message": "Messaggio",
    "add": "Aggiungi",
    "remove": "Rimuovi",
    "cm": "cm",
    "in": "pollici",
    "usd": "USD",
    "return": "Torna",
    "next": "Avanti",
    "store": "Negozio",
    "type": "Tipo",
    "cost": "Costo",
    "incurred-at": "Sostenuto il",
    "search-placeholder": "Cerca...",
    "more": "Altro...",
    "load-more": "Carica altro...",
    "status": "Stato",
    "enabled": "Abilitato",
    "disabled": "Disabilitato",
    "total": "Totale",
    "un-listed": "Non elencato",
    "global": "Globale",
    "store-specific": "Specifico del negozio",
    "ai-measurement-import": "Importazione misure con IA",
    "included": "Incluso",
    "not-included": "Non incluso"
  },
  "snackbar": {
    "successfully-updated-your-preferences": "Le tue preferenze sono state aggiornate con successo",
    "failed-to-update-your-preferences": "Impossibile aggiornare le tue preferenze"
  },
  "import": {
    "upload-file": "Carica file",
    "sheet-import": {
      "title": "Carica misure da un file",
      "dropzone": {
        "title": "Trascina qui un file",
        "accepted-types": "{{types}}: un file alla volta",
        "browse": "Sfoglia file"
      },
      "hint": "Per risultati migliori: una sola tabella con taglie corrispondenti alle varianti di questa tabella taglie e intestazioni nella prima riga o colonna. Per una foto o uno screenshot, assicurati che sia nitida, frontale e ritagliata sulla sola tabella.",
      "example": {
        "caption": "Esempio di layout accettato:",
        "size": "Taglia",
        "chest": "Petto (cm)",
        "waist": "Vita (cm)"
      },
      "error": {
        "invalid-type": "Questo tipo di file non è supportato. Carica uno di questi: {{types}}.",
        "heic-unsupported": "Le foto HEIC (il formato dell'iPhone) non sono supportate. Esporta la foto in JPG o PNG e carica quel file.",
        "file-too-large": "Il file è troppo grande. La dimensione massima è {{maxSizeMb}} MB."
      },
      "submit": "Carica e rivedi le modifiche",
      "running": {
        "this-chart": "È già in corso un'importazione per questa tabella taglie.",
        "other-chart": "È già in corso un'importazione per un'altra tabella taglie. È possibile eseguire una sola importazione alla volta.",
        "open-import": "Visualizza l'importazione"
      },
      "accepted-files-tooltip": "File accettati: {{types}}",
      "button": {
        "importing": "Importazione… {{progress}}%",
        "review": "Rivedi importazione"
      }
    }
  },
  "size-recommender": {
    "form": {
      "title": "Trova la tua taglia migliore",
      "subtitle": "Alcuni dettagli rapidi per una vestibilità migliore",
      "shopping-for": "ACQUISTI PER",
      "women": "Donna",
      "men": "Uomo",
      "other": "Altro",
      "measurements": "MISURE",
      "height": "Altezza",
      "height-required": "L'altezza è obbligatoria",
      "min-height": "L'altezza minima è 1",
      "weight": "Peso",
      "weight-required": "Il peso è obbligatorio",
      "min-weight": "Il peso minimo è 1",
      "preferred-fit": "Vestibilità preferita"
    },
    "result": {
      "suggested-size": "Taglia suggerita:",
      "no-fit": "Purtroppo sembra che al momento non abbiamo una taglia ideale. Ti consigliamo di controllare più tardi per ulteriori opzioni.",
      "verdict": "Verdetto:",
      "similar-variants": "Varianti simili:",
      "proceed": "Procedi con questa variante",
      "estimate-disclaimer": "(Stima basata sul brand e sulle informazioni dell'utente, i risultati possono variare.)"
    },
    "ai": {
      "upgrade-title": "Aggiorna il tuo piano per sbloccare il consiglio IA sulle taglie",
      "upgrade-description": "Una funzionalità che aiuta i tuoi clienti a trovare sempre la taglia giusta. La nostra IA analizza i dettagli del prodotto e gli input dei clienti per fornire suggerimenti personalizzati sulle taglie, in modo che gli acquirenti acquistino con fiducia e tu veda meno resi e cambi. Aggiorna ora per offrire questa esperienza nel tuo negozio.",
      "image-alt": "Consiglio sulle taglie",
      "upgrade-enable": "Aggiorna e abilita ora",
      "explore-plans": "Esplora altri piani",
      "failed-load-recommendations": "Impossibile caricare i consigli",
      "failed-fetch-plans": "Impossibile recuperare i piani",
      "form-tab": "Modulo",
      "result-tab": "Risultato"
    },
    "basic": {
      "measurements-required-title": "Aggiungi prima le misure",
      "measurements-required-description": "Il consiglio taglia di base abbina gli acquirenti a una taglia usando le misure di questa tabella. Aggiungi le misure alla tabella, poi attivalo."
    }
  },
  "chart-limit": {
    "title-size": "Hai raggiunto il limite di tabelle taglie pubblicate",
    "title-table": "Hai raggiunto il limite di tabelle a griglia pubblicate",
    "description-size": "Il tuo piano ti consente di pubblicare {{limit}} tabelle taglie e ne hai {{usage}} pubblicate. Questa tabella è stata salvata come bozza. Aggiorna il piano per pubblicarne altre, oppure annulla la pubblicazione di una tabella che non ti serve più.",
    "description-table": "Il tuo piano ti consente di pubblicare {{limit}} tabelle a griglia e ne hai {{usage}} pubblicate. Questa tabella è stata salvata come bozza. Aggiorna il piano per pubblicarne altre, oppure annulla la pubblicazione di una tabella che non ti serve più.",
    "upgrade-plan": "Aggiorna piano",
    "explore-plans": "Esplora i piani",
    "failed-fetch-plans": "Impossibile caricare i piani. Riprova.",
    "image-alt": "Illustrazione della tabella",
    "onboarding-saved-as-draft": "La tua tabella è stata salvata come bozza perché hai raggiunto il limite di tabelle pubblicate del tuo piano. Potrai pubblicarla dopo aver aggiornato il piano o annullato la pubblicazione di un'altra tabella."
  },
  "help-centre": "Centro assistenza",
  "dimension-inputs": {
    "add-measurement": "Aggiungi misura"
  },
  "variant-editor": {
    "option-name": "Nome opzione",
    "option-values": "Valori opzione",
    "option-placeholder": "Taglia / Colore / Tessuto",
    "add-option": "Aggiungi un'altra opzione"
  },
  "dimension": {
    "shoulder": "Spalla",
    "bust": "Busto",
    "waist": "Vita",
    "arm": "Braccio",
    "sleeve": "Manica",
    "hip": "Fianchi",
    "crotch": "Cavallo",
    "leg": "Gamba",
    "thigh": "Coscia",
    "length": "Lunghezza",
    "bottom_width": "Larghezza fondo",
    "chest": "Petto",
    "inside_leg": "Cavallo interno",
    "back_length": "Lunghezza dietro",
    "front_length": "Lunghezza davanti",
    "front_rise": "Cavallo anteriore",
    "back_rise": "Cavallo posteriore",
    "leg_opening": "Apertura gamba",
    "overbust": "Sopraseno",
    "underbust": "Sottoseno",
    "groups": {
      "tops": "Capi superiori",
      "bottoms": "Capi inferiori",
      "generals": "Generali"
    }
  },
  "analytic": {
    "range": {
      "1m": "1 mese",
      "3m": "3 mesi",
      "6m": "6 mesi",
      "1y": "1 anno"
    }
  },
  "store-history": {
    "a-restore-is-already-running-for-this-store": "È già in corso un ripristino per questo negozio. Attendi che finisca e riprova.",
    "a-snapshot-is-taken-only-on-days-you-change-something": "Una copia viene creata solo nei giorni in cui cambi qualcosa.",
    "actor": {
      "merchant": "tu",
      "support": "Assistenza Goodchart",
      "system": "Shopify"
    },
    "billing-plan-login-and-connected-integrations-are-not-touched": "Fatturazione, piano, accesso e integrazioni collegate non vengono toccati.",
    "blocked": {
      "entity-exists": "Già ricreato — ripristina invece",
      "entity-missing": "Non esiste più — ripristina invece",
      "unsupported": "Non annullabile — ripristina invece",
      "value-changed": "Modificato da allora — ripristina invece"
    },
    "changes": "Modifiche",
    "discard-unsaved-changes": "Vuoi scartare le modifiche non salvate?",
    "dont-ask-again-in-this-session": "Non chiedere più in questa sessione",
    "earlier": "Prima",
    "history": "Cronologia",
    "history-starts-from-your-first-snapshot": "La cronologia parte dalla tua prima copia",
    "label": {
      "category-created": "Categoria {{name}} creata",
      "category-deleted": "Categoria {{name}} eliminata",
      "category-updated": "Categoria {{name}} modificata",
      "chart-created": "Guida {{name}} creata",
      "chart-deleted": "Guida {{name}} eliminata",
      "chart-updated": "Guida {{name}} modificata",
      "dimension-created": "Misura {{name}} creata",
      "dimension-deleted": "Misura {{name}} eliminata",
      "dimension-updated": "Misura {{name}} modificata",
      "draft-assignment-rules": "Regole di assegnazione modificate",
      "draft-edited": "Tabella modificata",
      "draft-guide": "Guida alla misurazione modificata",
      "draft-labels": "Etichette taglia modificate",
      "draft-measurements": "Misure modificate",
      "draft-model": "Misure della modella modificate",
      "draft-publication": "Pubblicazione modificata",
      "draft-renamed": "Tabella rinominata",
      "draft-size-recommender": "Consigliatore di taglia modificato",
      "draft-variants": "Varianti modificate",
      "keyword-created": "Parola chiave {{name}} creata",
      "keyword-deleted": "Parola chiave {{name}} eliminata",
      "keyword-updated": "{{count}} parole chiave modificate",
      "products-assigned": "{{count}} prodotti assegnati",
      "profile-updated": "Profilo del negozio aggiornato",
      "store-restored": "Negozio ripristinato al {{date}}",
      "table-chart-created": "Tabella {{name}} creata",
      "table-chart-deleted": "Tabella {{name}} eliminata",
      "table-chart-updated": "Tabella {{name}} modificata"
    },
    "no-changes-since-then": "Nessuna modifica da allora.",
    "no-snapshots-yet": "Ancora nessuna copia",
    "nothing-created-since-then-will-be-deleted": "Non verrà eliminato nulla di ciò che è stato creato da allora.",
    "plus-x-more": "+{{x}} altri",
    "reloading-the-dashboard": "Ricaricamento della dashboard…",
    "restore": "Ripristina",
    "restore-confirmation-word": "RIPRISTINA",
    "restore-instead": "Ripristina invece",
    "restore-your-store": "Ripristina il tuo negozio",
    "restoring-your-store-do-not-close-this-window": "Ripristino del negozio in corso. Non chiudere questa finestra.",
    "since-the-x-snapshot": "Dalla copia del {{x}}",
    "snapshots": "Copie",
    "the-change-was-undone-but-the-page-could-not-refresh": "La modifica è stata annullata, ma questa pagina non si è potuta aggiornare. Ricarica per vederla.",
    "this-backup-predates-image-protection": "Questa copia è precedente alla protezione delle immagini, quindi le immagini eliminate da allora non sono recuperabili.",
    "this-changes-what-shoppers-see-on-your-product-pages-within-seconds": "Questo cambia in pochi secondi ciò che i clienti vedono sulle pagine prodotto.",
    "this-changes-what-shoppers-see-right-away": "Questo cambia subito ciò che vedono i clienti.",
    "this-puts-your-store-back-to-how-it-was-on-x": "Riporta il tuo negozio com’era il {{x}}.",
    "this-reverses-x-actions-up-to-and-including-y": "Questo annulla {{x}} azioni, fino a «{{y}}» inclusa.",
    "trigger": {
      "daily": "Giornaliera",
      "install": "All’installazione di Goodchart",
      "manual": "Manuale (assistenza)",
      "migration": "Prima copia",
      "pre-restore": "Prima del ripristino",
      "reinstall": "Alla reinstallazione di Goodchart"
    },
    "type-x-to-confirm": "Digita {{x}} per confermare",
    "undid-x": "«{{x}}» annullata",
    "undo-a-saved-change": "Annulla una modifica salvata",
    "undo-to-here": "Annulla fino a qui",
    "undo-x-saved-y": "Annullare «{{x}}», salvata {{y}}?",
    "unsaved": "Non salvate",
    "we-could-not-load-your-history": "Non è stato possibile caricare la cronologia.",
    "we-could-not-load-your-snapshots": "Non è stato possibile caricare le tue copie.",
    "we-could-not-restore-your-store": "Non è stato possibile ripristinare il tuo negozio.",
    "we-could-not-work-out-what-would-change": "Non è stato possibile calcolare cosa cambierebbe.",
    "we-take-a-snapshot-of-your-current-store-first-so-this-can-be-undone": "Creiamo prima una copia del negozio attuale, così l’operazione è annullabile.",
    "we-take-a-snapshot-of-your-store-each-day-it-changes": "Creiamo una copia del tuo negozio ogni giorno in cui cambia. La cronologia comparirà qui appena viene creata la prima.",
    "what-comes-back": "Cosa torna",
    "what-is-lost": "Cosa si perde",
    "working-out-what-would-change": "Calcolo di ciò che cambierebbe…",
    "x-assignments": "{{x}} associazioni",
    "x-charts": "{{x}} guide",
    "x-images-cannot-be-brought-back": "Non è possibile recuperare {{x}} immagini: sono state eliminate più di 37 giorni fa.",
    "x-images-could-not-be-recovered": "Non è stato possibile recuperare {{x}} immagini: sono state eliminate più di 37 giorni fa.",
    "x-items-created-since-then-will-be-deleted": "Verranno eliminati {{x}} elementi creati da allora, tra cui:",
    "x-items-will-be-recreated": "Verranno ricreati {{x}} elementi.",
    "x-no-longer-exists-after-the-undo": "«{{x}}» non esiste più dopo l’annullamento.",
    "x-table-charts": "{{x}} tabelle",
    "you-have-unsaved-changes-to-x-undoing-will-discard-them": "Hai modifiche non salvate su «{{x}}». Annullando le perderai.",
    "your-store-has-been-restored": "Il tuo negozio è stato ripristinato."
  },
  "chart-import": {
    "progress": {
      "stage": {
        "reading-file": "Lettura del file",
        "understanding-table": "Analisi della tabella",
        "matching-measurements": "Abbinamento delle misure",
        "building-chart": "Creazione della tabella taglie"
      },
      "reconnecting": "Riconnessione in corso: attendi un momento, i tuoi progressi non sono andati persi.",
      "keep-working": "Puoi continuare a lavorare: ti avviseremo quando sarà pronto.",
      "cancel": "Annulla importazione",
      "cancel-confirm": {
        "title": "Annullare questa importazione?",
        "message": "Il file caricato verrà eliminato e questa importazione non potrà essere ripresa.",
        "keep": "Continua ad attendere",
        "discard": "Annulla importazione"
      },
      "ready": {
        "title": "Tabella taglie pronta per la revisione",
        "action": "Rivedi le modifiche"
      }
    },
    "failure": {
      "unreadable-file": {
        "message": "La foto era troppo sfocata o scura per essere letta. Una foto più nitida e ben illuminata funziona meglio."
      },
      "no-table-found": {
        "message": "Non abbiamo trovato una tabella taglie in questo file."
      },
      "unsupported-layout": {
        "message": "Non siamo ancora in grado di leggere il layout di questa tabella."
      },
      "model-timeout": {
        "message": "Ci è voluto troppo tempo: di solito è un problema temporaneo."
      },
      "internal": {
        "message": "Si è verificato un problema da parte nostra durante l'importazione della tua tabella taglie."
      },
      "action": {
        "retry": "Riprova",
        "try-another-photo": "Prova un'altra foto",
        "try-another-file": "Prova un altro file",
        "other-methods": "Altri metodi"
      }
    },
    "diff-review": {
      "title": "Rivedi le modifiche",
      "subtitle": "Deseleziona ciò che non vuoi applicare a questa tabella taglie.",
      "load-error": "Non è stato possibile caricare le modifiche di questa importazione.",
      "no-changes": "Nessuna misura è cambiata.",
      "grid": {
        "variant": "Taglia",
        "dimension": "Misura",
        "old-value": "Attuale",
        "new-value": "Nuovo"
      },
      "unmatched-variants": "Taglie nel file che non corrispondono a questa tabella taglie:",
      "unmapped-dimensions": "Colonne che non siamo riusciti ad associare a una misura:",
      "apply": {
        "button": "Applica modifiche ({{count}})",
        "success": "Tabella taglie aggiornata ({{count}} modifiche applicate)",
        "generic-error": "Non è stato possibile applicare queste modifiche. Riprova."
      },
      "cancel": {
        "button": "Annulla importazione"
      }
    },
    "review": {
      "cancel-confirm": {
        "title": "Annullare questa importazione?",
        "message": "Il file caricato e le modifiche della revisione verranno eliminati. Questa importazione non potrà essere ripresa.",
        "keep": "Continua la revisione",
        "discard": "Annulla importazione"
      }
    },
    "page": {
      "title": "Importa misure",
      "empty": {
        "title": "Nessuna importazione in corso per questa tabella taglie",
        "message": "Carica un foglio di calcolo o una foto di una tabella taglie per aggiornare le misure di questa tabella."
      }
    },
    "upgrade": {
      "title": "Importa le misure con l'IA",
      "description": "Carica un foglio di calcolo o una foto di una tabella taglie e compileremo noi le misure di questa tabella. L'importazione misure con IA non è inclusa nel tuo piano attuale. Aggiorna il piano per usarla.",
      "upgrade-plan": "Aggiorna piano",
      "explore-plans": "Esplora i piani",
      "failed-fetch-plans": "Impossibile caricare i piani. Riprova.",
      "image-alt": "Illustrazione di una tabella taglie"
    }
  },
  "promotion": {
    "BlackFriday": {
      "name": "Black Friday",
      "chip": "Prezzo del Black Friday",
      "popup": {
        "eyebrow": "Black Friday · Cyber Monday",
        "headline": "Fino al {{percent}}% di sconto",
        "subheadline": "sui piani Goodchart",
        "body": "Prepara le tue tabelle taglie per la settimana più intensa dell'anno. Taglie chiare significano meno domande \"mi andrà bene?\" e meno resi.",
        "feature-recommender": "Consulente taglie con IA che suggerisce la taglia a ogni cliente",
        "feature-import": "Importazione con IA che trasforma un file o un'immagine in una tabella taglie",
        "feature-analytics": "Analisi su come i clienti usano le tue tabelle taglie",
        "cta": "Vedi le offerte",
        "later": "Forse più tardi"
      },
      "show-offer": "Mostra l'offerta del Black Friday"
    },
    "every-plan": "{{percent}}% di sconto su tutti i piani",
    "up-to": "Fino al {{percent}}% di sconto",
    "switch-to": "Passa a {{price}} $/{{interval}}",
    "switch-from": "Hai {{name}} a {{price}} $/{{interval}}. Stesse funzioni, il {{percent}}% in meno.",
    "switch-note-monthly": "Shopify ti chiede di approvare il nuovo prezzo e ti accredita il resto del mese.",
    "switch-note-annual": "Shopify ti chiede di approvare il nuovo prezzo, che parte dal rinnovo del {{date}}.",
    "switch-note-annual-undated": "Shopify ti chiede di approvare il nuovo prezzo, che parte dal prossimo rinnovo."
  },
  "agent-chat": {
    "open": "Apri la chat di assistenza",
    "close": "Chiudi la chat di assistenza",
    "expand": "Ingrandisci la chat",
    "collapse": "Riduci la chat",
    "title": "Assistenza Goodchart",
    "history": "Conversazioni",
    "back": "Torna alla conversazione",
    "new": "Nuova conversazione",
    "placeholder": "Fai una domanda su Goodchart",
    "send": "Invia",
    "welcome": "Ciao! Chiedimi qualsiasi cosa su Goodchart: creare tabelle taglie, la guida alle taglie nel tuo negozio o il tuo piano.",
    "history-empty": "Ancora nessuna conversazione.",
    "unread": "Nuova risposta",
    "you": "Tu",
    "merchant": "Commerciante",
    "assistant": "Assistente Goodchart",
    "team": "Team Goodchart",
    "typing": "Sta scrivendo…",
    "used-articles": "Risposta dagli articoli di aiuto",
    "retry": "Riprova",
    "activity": {
      "articles": "Sta leggendo gli articoli di aiuto…",
      "store": "Sta controllando il tuo negozio…",
      "code": "Sta verificando come funziona Goodchart…",
      "team": "Sta passando la richiesta al team Goodchart…"
    },
    "error": {
      "rate-limited": "Stai inviando messaggi troppo velocemente. Riprova tra {{seconds}} secondi. Se ti serve il team Goodchart, chiedimelo appena potrai scrivere di nuovo.",
      "daily-cap": "Hai raggiunto il limite di messaggi di oggi. Riprova domani e, se ti serve ancora il team Goodchart, chiedimelo allora.",
      "disabled": "L’assistente di supporto non è disponibile al momento.",
      "reply-failed": "La risposta non è arrivata.",
      "unknown": "Qualcosa è andato storto."
    },
    "placeholder-team": "Aggiungi dettagli per il team Goodchart",
    "unavailable": "L’assistente di supporto non è disponibile al momento, quindi non accetta nuove domande. Le conversazioni già in mano al team Goodchart restano aperte nella cronologia.",
    "waiting": {
      "title": "In attesa del team Goodchart.",
      "body": "Risponderanno qui e riceverai una notifica. Nel frattempo puoi aggiungere dettagli."
    },
    "starters": {
      "create-chart": "Come creo una tabella taglie?",
      "no-chart": "Quali miei prodotti non hanno una tabella taglie?",
      "not-showing": "Perché la mia tabella taglie non compare nel negozio?",
      "charts-left": "Quante altre tabelle posso pubblicare?"
    },
    "feedback": {
      "helpful": "Utile",
      "not-helpful": "Non utile",
      "thanks": "Grazie per il feedback.",
      "comment-placeholder": "Cosa non andava o mancava? (facoltativo)",
      "send": "Invia",
      "skip": "Salta",
      "rated-up": "Valutato utile",
      "rated-down": "Valutato non utile"
    }
  }
}
